import React from "react";
import { Box, Typography } from "@mui/material";
import Logo from "../../images/logo_anota.svg";

const CompanyUnavailable = () => {
  return (
    <Box
      height="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      overflow="hidden"
    >
      <Box
        component="img"
        src={Logo}
        alt="Anota Reservas"
        sx={{
          width: { xs: "180px", md: "180px" },
          height: "auto",
          marginBottom: "24px",
        }}
      />
      <Typography
        sx={{ fontWeight: 700, letterSpacing: "0.2" }}
        fontSize="24px"
        color="#22303E"
        marginBottom="16px"
      >
        Empresa Indisponível
      </Typography>
      <Typography
        sx={{ fontWeight: 400, letterSpacing: "0.2" }}
        fontSize="14px"
        color="#22303E"
      >
        Por favor, entre em contato diretamente com a empresa para fazer sua
        reserva.
      </Typography>
    </Box>
  );
};

export default CompanyUnavailable;
